import { render, staticRenderFns } from "./ManualSubmit.vue?vue&type=template&id=45618655&"
import script from "./ManualSubmit.vue?vue&type=script&lang=js&"
export * from "./ManualSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports